import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import logoColor from '../../assets/HT_Horizontal_Color.svg';
import logoOnDark from '../../assets/HT_Horizontal_Color_OnDark.svg';
import { company, navItems } from '../../content/site';
import PageContainer from '../layout/PageContainer';

/** Page close: a short line, the mark, and navigation. The inquiry form lives on Contact. */
const Footer = () => {
  const theme = useTheme();
  const dark = theme.palette.mode === 'dark';

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        borderTop: dark ? 2 : 1,
        borderColor: dark ? 'primary.main' : 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <PageContainer>
        <Typography sx={{ maxWidth: 560 }}>
          Custom software for teams improving what they have and building what they need next.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 2,
            alignItems: 'center',
            justifyContent: 'space-between',
            mt: 5,
            pt: 3,
            borderTop: 1,
            borderColor: 'divider',
          }}
        >
          <Button component={Link} to="/" sx={{ p: 0.5 }} aria-label="Hochbegabt Technology, home">
            <Box
              component="img"
              src={dark ? logoOnDark : logoColor}
              alt=""
              sx={{ height: 36, width: 'auto', display: 'block' }}
            />
          </Button>

          <Box component="nav" aria-label="Footer" sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {navItems.map(({ label, to }) => (
              <Button key={to} component={Link} to={to} sx={{ color: 'text.primary' }}>
                {label}
              </Button>
            ))}
          </Box>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          © {new Date().getFullYear()} {company.name}
        </Typography>
      </PageContainer>
    </Box>
  );
};

export default Footer;
